/* global swal:false */
(function() {
  'use strict';

  angular
    .module('admin.users.details.purchases', [
      'admin.users.details.purchases.service'
    ])
    .controller('PurchasesAdminCtrl', PurchasesAdminCtrl);

  /** @ngInject */
  function PurchasesAdminCtrl($scope, $stateParams, UsersService, PurchaseService) {
    var vm = this;
    vm.items = [];
    vm.userId = $stateParams.parentId;
    vm.totalUsers = 0;
    vm.usersPerPage = 25;
    vm.oldPage = 0;
    vm.currentPage = 25;
    vm.first = true;
    vm.totalItems = 0;
    vm.pagination = {
      current: 1
    };

    vm.sortType = '';
    vm.sortReverse = false;

    load(1);

    var oldSortType;
    function load(pageNumber){
      if (pageNumber === 1) {
        vm.pagination.current = 1;
      }

      if (!vm.first) {
        vm.currentPage = pageNumber * 25;
        vm.oldPage = vm.currentPage - 25;
      }
      else {
        vm.first = false;
      }

      oldSortType = angular.copy(vm.sortType);
      UsersService.listPurchaseLogs($stateParams.parentId, vm.oldPage, 25, vm.sortType).then(success);

      function success(result){
        if (vm.totalItems === 0) {
          vm.totalItems = result.ct;
        }
        for (var i = 0; i < result.results.length; i++) {
          result.results[i]['ts-m'] = new Date(parseInt(result.results[i]['ts-m'].toString().substring(0, result.results[i]['ts-m'].toString().length - 3)));

          if (result.results[i].st === 0) {
            switch(result.results[i]['st-err']) {
              case 0:
                result.results[i].status = 'Error - UNKNOWN';
                break;
              case 1:
                result.results[i].status = 'Error - CONNECTION FAILED';
                break;
              case 2:
                result.results[i].status = 'Error - MALFORMED RESPONSE';
                break;
              case 3:
                result.results[i].status = 'Error - MALFORMED RECEIPT';
                break;
              case 4:
                result.results[i].status = 'Error - INVALID RECEIPT';
                break;
              case 5:
                result.results[i].status = 'Error - WRONG APP';
                break;
              case 6:
                result.results[i].status = 'Error - BAD PRODUCT';
                break;
              case 7:
                result.results[i].status = 'Error - ALREADY CLAIMED';
                break;
            }
          } else if (result.results[i].st === 1){
            result.results[i].status = 'STARTED';
          } else if (result.results[i].st === 2){
            result.results[i].status = 'COMPLETE';
          }


          switch(result.results[i].store) {
            case 0:
              result.results[i].storeText = 'UNKNOWN_STORE';
              break;
            case 1:
              result.results[i].storeText = 'APP_STORE';
              break;
            case 2:
              result.results[i].storeText = 'PLAY_STORE';
              break;
            case 3:
              result.results[i].storeText = 'AMAZON_STORE';
              break;
          }

        }

        vm.sortType = oldSortType;
        vm.items = result.results;
      }
    }

    vm.payCoins = function(id){
      PurchaseService.retryReceipt(id).then(function(){
        load(1);
      });
    };

    vm.pageChanged = function(newPage) {
      vm.sortType = oldSortType;
      load(newPage);
    };

    vm.sort = function(type){
      vm.sortReverse = !vm.sortReverse;
      if (vm.sortReverse) {
        vm.sortType = type + '-asc';
      } else {
        vm.sortType = type + '-desc';
      }
      load(vm.pagination.current);
    };

  }

})();
